import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const getAppraisals = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/employeeperformance/getemployeelist${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const getAppraisalsMeetings = (query, token, teamsToken) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/employeeperformance/teams/meetinglist${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
      "x-ms-token": teamsToken,
    },
  });
};
export const createInitiateAppraisal = (data, token) =>
  axios.post(`${baseUrl}/employeeperformance/addemployeelist`, data, {
    headers: {
      authorization: token,
    },
  });

export const setMyAppraisal = (data, token) => {
  return axios.post(`${baseUrl}/employeeperformance/submitemployeekra`, data, {
    headers: {
      authorization: token,
    },
  });
};
export const postKraByManager = (data, token) => {
  return axios.patch(
    `${baseUrl}/employeeperformance/submitkrabymananger`,
    data,
    {
      headers: {
        authorization: token,
      },
    }
  );
};

export const getemployeeAppraisaldatabyId = (id, token) => {
  return axios.get(`${baseUrl}/employeeperformance/getemployeekrabyId:/${id}`, {
    headers: {
      authorization: token,
    },
  });
};

export const getLatestStatusbyId = (id, token) => {
  return axios.get(`${baseUrl}/employeeperformance/getstatus/${id}`, {
    headers: {
      authorization: token,
    },
  });
};

export const setUpdataStatus = (data, token) => {
  return axios.post(`${baseUrl}/employeeperformance/updatestatus`, data, {
    headers: {
      authorization: token,
    },
  });
};

export const getMeetingDetailsbyId = (id, token) => {
  return axios.get(
    `${baseUrl}/employeeperformance/teams/meetingDetailsbyId/${id}`,
    {
      headers: {
        authorization: token,
      },
    }
  );
};
